import { createFileRoute } from "@tanstack/react-router";
import { LegalPage, legalHead } from "@/components/LegalPage";
import { LegacyPolicyBody } from "@/components/LegacyPolicyBody";
import { legacyPolicies } from "@/data/legacy-policies";

export const Route = createFileRoute("/modern-slavery-act-policy")({
  head: () => {
    const head = legalHead({
      title: "Modern Slavery Act Policy | Preserve Earth",
      description:
        "How Preserve Earth keeps its business and supply chains free from slavery and human trafficking, including supplier due diligence and staff awareness.",
      path: "/modern-slavery-act-policy",
      crumbName: "Modern Slavery Act Policy",
    });
    return { ...head, meta: [...head.meta, { name: "robots", content: "index, follow" }] };
  },
  component: ModernSlaveryPage,
});

function ModernSlaveryPage() {
  return (
    <LegalPage
      crumb={{ name: "Modern Slavery Act Policy", path: "/modern-slavery-act-policy" }}
      showPolicyContact={false}
      intro={<LegacyPolicyBody blocks={legacyPolicies.modernSlavery} />}
    />
  );
}
